import {
  KuxImageRail,
  KuxMediaAssetType,
  KuxMenuItem,
  PresentationAdditionalTypeEnum,
  RatingProviderEnum,
  UIDAPresentationTypeEnum,
} from '@kaltura-ott/tvpil';

import type { RatingInfo } from '../../../utils';

export enum RailImageType {
  Compact,
  Default,
  Medium,
}

export type ItemImageOptions = {
  imageType: RailImageType;
  defaultHeight?: number;
};

/**
 * Interface for rail like data structures
 */
export interface DataRailV2 {
  subtype: UIDAPresentationTypeEnum | PresentationAdditionalTypeEnum;
  isReady: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any;
  totalItemsCount: number;
  isLoadingState: boolean;
  presentEntitlementIndicator: boolean;
  presentRating: boolean;
  presentRatingSourceLogo: boolean;
  ratingProvider?: RatingProviderEnum;
  railHeight: number;
  itemDefaultWidth: number;
  showMoreItem?: KuxMenuItem;

  itemImage(assetData: KuxMediaAssetType, options?: ItemImageOptions): KuxImageRail;

  fullyLoaded: boolean;
  presentShowMore: boolean;

  init(): Promise<void>;
  onInvisible(): void;
  resetStore(): void;
  setVisibleIndex(index: number): void;
  setInvisibleIndex(index: number): void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getRating(card: any): RatingInfo | null;
  loadDataPaginated(pagesAmount: number): Promise<void>;
}
